import Vue from 'vue'
import Vuex from 'vuex'

import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex)

export default new Vuex.Store({
  // 全局参数
  state: {
    // 生产
    offlineUrl: 'https://trd-api.jianzhumucai.com/trd-api/',
    // 测试
    // offlineUrl:'https://www.jzmf.top/trd-api/',
    //聚木
    otherlineUrl: 'https://cms.jumugongli.com/',
    // 阿里
    imgUrl: 'https://cdn.jianzhumucai.com/',

    region: [],
    caizhi:[],
    searValue:{},
    isDetail:false
  },
  //this.$store.commit，set方法,必须同步执行
  mutations: {
    region(state, provider) {
      state.region = provider;
    },
    caizhi(state, provider) {
      state.caizhi = provider;
    },
    searValue(state, provider) {
      state.searValue = provider;
    },
    isDetail(state, provider) {
      state.isDetail = provider;
    }



  },
  //get方法，store的计算属性，类似于computed,对state里的数据进行一些过滤改造
  getters: {},
  //this.$store.dispatch，可异步同步提交至actions，最后commit提交给mutation
  actions: {},
  //这里是为了给全局变量分组，所以需要写提前声明其他store文件，然后引入这里
  modules: {},
  plugins: [createPersistedState({
    storage: window.sessionStorage,
    reducer(val) {
      return {
        region: val.region,
        caizhi: val.caizhi,
        searValue:val.searValue,
        isDetail:val.isDetail
      }
    }
  })]
})



// WEBPACK FOOTER //
// ./src/store/index.js